import { Injectable, OnDestroy, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { authenticationSelectors } from '@wam/authentication';
import { settingsSelectors, State, TabDisplayInterface, UserRole } from '@wam/shared';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { isInternalAdminOrAccountAdminOrSupportEngineer } from '../authentication/user.data';

@Injectable({
  providedIn: 'root',
})
export class FamiliesTabDisplayService implements TabDisplayInterface, OnDestroy {
  private store = inject<Store<State>>(Store);

  private destroyed$ = new Subject<void>();

  isFirst(): Observable<boolean> {
    return of(false);
  }

  shouldShow(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(select(settingsSelectors.getUserType)),
      this.store.pipe(select(authenticationSelectors.getUserRoles)),
    ]).pipe(
      map(
        ([userType, userRoles]) =>
          isInternalAdminOrAccountAdminOrSupportEngineer(userType, userRoles) ||
          userRoles.includes(UserRole.ENROLLMENT_SUPPORT),
      ),
      takeUntil(this.destroyed$),
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
